import * as ng from 'angular';

class RetryWSModalController implements ng.IController {

    static $inject: string[] = [
        '$scope'
    ];
    private close: any;
    constructor(
        private $scope: any // ng.IScope,
    ) {
        $scope.attempts = $scope.$parent.$resolve.settings.attempts;

        $scope.retry = () => {
            this.close({ $value: true });
        };
        $scope.cancel = () => {
            this.close({ $value: false });
        };
    }
}

export const RetryWSModalComponent: ng.IComponentOptions = {
    template: require('./retry-ws-modal.html'),
    controller: RetryWSModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/retry-ws-modal/retry-ws-modal.ts